import React from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useTranslation } from "react-i18next";

const LanguageDialog = ({ setLanguage }) => {
  const { t } = useTranslation();
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const changeLanguage = useContextSelector(AuthContext, (ctx) => ctx.changeLanguage);

  return (
    <div
      role="document"
      tabIndex={0}
      data-v-9cead1be=""
      className="v-dialog__content v-dialog__content--active"
      style={{ zIndex: 202 }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{ transformOrigin: "center center", maxWidth: "300px" }}
      >
        <div data-v-9cead1be="" className="dialog-card v-card v-sheet theme--light">
          <div data-v-9cead1be="" className="row no-gutters justify-space-between dialog-header">
            <div data-v-9cead1be="" className="d-flex flex-column pl-6 py-4 col col-10">
              <label
                data-v-9cead1be=""
                className="dialog-title text-capitalize d-block full-width white--text"
              >
                {t("CurrencyLanguage")}
              </label>
            </div>
            <div
              data-v-9cead1be=""
              className="d-flex justify-content-center align-content-center col col-2"
            >
              <button
                data-v-9cead1be=""
                type="button"
                onClick={() => setLanguage(false)}
                className="v-icon notranslate full-width v-icon--link mdi mdi-close theme--light white--text dialog-close-icon login"
              />
            </div>
          </div>

          <div data-v-9cead1be="" className="row dialog-row no-gutters pa-0">
            <div className="language_panel col">
              <div className="row d-flex flex-nowrap no-gutters justify-space-between align-content-center">
                <div className="align-self-center flex-shrink-1">
                  <div
                    className="v-avatar language-button"
                    style={{ height: "35px", minWidth: "35px", width: "35px" }}
                  >
                    <img src="/static/image/country/BDT.svg" alt={t("Altwinx9CricketExchange")} />
                  </div>
                </div>
                <div className="align-self-center flex-shrink-1 mx-2">
                  <label>৳ BDT</label>
                </div>
                <div className="row align-self-center flex-grow-1 no-gutters justify-center">
                  <div className="pl-2 flex-grow-1 v-item-group theme--light v-btn-toggle v-btn-toggle--borderless v-btn-toggle--dense v-btn-toggle--group">
                    <button
                      type="button"
                      value="BDTen"
                      onClick={() => changeLanguage("en")}
                      className={
                        "font-weight-bold text-capitalize full-width v-btn v-btn--outlined theme--light v-size--default" +
                        (lang === "en" ? " v-item--active v-btn--active" : "")
                      }
                    >
                      <span className="v-btn__content">{t("English")}</span>
                    </button>
                  </div>
                  <div className="pl-2 flex-grow-1 v-item-group theme--light v-btn-toggle v-btn-toggle--borderless v-btn-toggle--dense v-btn-toggle--group">
                    <button
                      type="button"
                      value="BDTbd"
                      onClick={() => changeLanguage("bn")}
                      className={
                        "font-weight-bold text-capitalize full-width v-btn v-btn--outlined theme--light v-size--default" +
                        (lang === "bn" ? " v-item--active v-btn--active" : "")
                      }
                    >
                      <span className="v-btn__content">{t("Bengali")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row mt-2 no-gutters" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageDialog;
